import Wrapper from "./Wrapper";
import Confirm from "./Confirm";
import ResetPassword from "./ResetPassword";

export default {
  Wrapper,
  Confirm,
  ResetPassword
};
